import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { Grid } from '@mui/material';
import _ from 'lodash';
import deepmerge from 'deepmerge';

import SelectField from '../../../common/select_field';
import { getAllFoodPartnersState } from '../../../../features/food_partner/get_all_food_partners';
import { getFoodPartnerOrderStatusOptions } from '../../../common/utils/food_partner_order_utils';
import FilterPaper from '../../../common/filter_paper';

const FoodPartnerFilters = ({ queryParams, setQueryParams }) => {
    const getAllFoodPartners = useSelector(getAllFoodPartnersState);

    const [foodPartnerId, setFoodPartnerId] = useState(queryParams?.foodPartnerId || 'none');

    const onSelectFoodPartnerChange = (event) => {
        setFoodPartnerId(event.target.value);
        setQueryParams(prevState => deepmerge(prevState, { foodPartnerId: event.target.value }));
    };

    return (
        <FilterPaper title="Filtry zamówień">
            <Grid container spacing={ 3 } alignItems="flex-start">
                <Grid item xs={ 12 } sm={ 6 } md={ 4 }>
                    <SelectField
                        size="small"
                        fullWidth
                        label="Status"
                        value={ _.pick(queryParams, ['status']).status || 'ALL' }
                        onChange={ (event) => setQueryParams(prevState => deepmerge(prevState, { status: event.target.value })) }
                        options={ [{ value: 'ALL', label: 'Wszystkie' }, ...getFoodPartnerOrderStatusOptions] }
                    />
                </Grid>
                <Grid item xs={ 12 } sm={ 6 } md={ 4 }>
                    <SelectField
                        size="small"
                        fullWidth
                        label="Dostawca"
                        value={ foodPartnerId }
                        onChange={ onSelectFoodPartnerChange }
                        options={ [{
                            value: 'none',
                            label: 'Nie wybrano'
                        }, ...(getAllFoodPartners?.data?.map(getFoodPartner => ({
                            value: getFoodPartner?.id,
                            label: getFoodPartner?.name
                        })) || [])] }
                    />
                </Grid>
            </Grid>
        </FilterPaper>
    );
};

export default FoodPartnerFilters;